import { PaymentStatusEnum, PaymentTypeEnum } from '@onArte/shared/database/enums';

export class OrderPaymentDetailsDTO {
  constructor(
    public paymentType: PaymentTypeEnum,
    public paymentStatus: PaymentStatusEnum | null,
    public paymentDate: number | null,
    public paymentUrl: string | null,
  ) {}
}
